import UsedCardboardBoxes from '@/components/HomebuyerOffers/UsedCardboardBoxes.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/offers/UsedCardboardBoxes',
  name: RouteNames.UsedCardboardBoxes,
  component: UsedCardboardBoxes,
};

export default route;
